import React, { Component } from 'react'
import { selectMode } from '../../../actions/commonActions'
import { connect } from 'react-redux'

export class HostToken extends Component { 
  componentDidMount() {
    this.props.selectMode('integration_guide')
  }
  state = {
    isSubmitClicked: false
  };
    render() {
  
      return (
        <div className="stepPageContainer">  
          <h3 className="stepPageTitle">Hosted Tokenization</h3>
          <p>Moneris Hosted Tokenization is a solution for online e-commerce merchants who do not want to handle
credit card numbers directly on their websites, yet want the ability to fully customize their check-out web
page appearance.<br/>
When an hosted tokenization transaction is initiated, the Moneris Gateway displays (on the merchant’s
behalf) a single text box on the merchant’s checkout page. The cardholder can then securely enter the
credit card information into the text box. Upon submission of the payment information on the checkout
page, Moneris Gateway returns a temporary token representing the credit card number to the merchant.
This is then used in an API call to process a financial transaction directly with Moneris to charge
the card. After receiving a response to the financial transaction, the merchant generates a receipt and
allows the cardholder to continue with online shopping.<br/>
For more details on how to implement the Moneris Hosted Tokenization feature, see the Hosted Solutions
Integration Guide. The guide can be downloaded from the Moneris Developer Portal at
            </p>
            <a href="https://developer.moneris.com" target="_blank" rel="noopener noreferrer">https://developer.moneris.com</a>                         
        </div>
      )
    }
}


const mapStateToProps = state => {
  const {mode} = state.common.sideNav;
  return { mode};
}

export default connect(mapStateToProps, { selectMode})(HostToken)



